import { Component, input } from '@angular/core';
import { IconPupil } from '../../icons/i-pupil';
import { IconTutor } from '../../icons/i-tutor';

@Component({
  selector: 'rid-dialog-line-indicator',
  imports: [IconPupil, IconTutor],
  templateUrl: './rid-dialog-line-indicator.html',
})
export class RidDialogLineIndicator {
  speaker = input.required<'LEFT' | 'RIGHT'>();
}
